module.exports = __webpack_public_path__ + "img/2Vi6iS.10c430d1.png";